import { DataItemType, DataType } from "components/EffectSearch/EffectSearch";

const directMemberWalletAttributes = [
  {
    label: "activeUnits",
    code: "customer.getWallet('').activeUnits",
    codeRegexMatcher: /^customer.getWallet+\(['"].*?['"]\).activeUnits$/g,
    parameter: "('')",
    parameterType: "wallet",
    dialogTitle: "activeUnitsWalletBalanceAttributes",
  },
  {
    label: "blockedUnits",
    code: "customer.getWallet('').blockedUnits",
    codeRegexMatcher: /^customer.getWallet+\(['"].*?['"]\).blockedUnits$/g,
    parameter: "('')",
    parameterType: "wallet",
    dialogTitle: "blockedUnitsWalletBalanceAttributes",
  },
  {
    label: "expiredUnitsConst",
    code: "customer.getWallet('').expiredUnits",
    codeRegexMatcher: /^customer.getWallet+\(['"].*?['"]\).expiredUnits$/g,
    parameter: "('')",
    parameterType: "wallet",
    dialogTitle: "expiredUnitsWalletBalanceAttributes",
  },
  {
    label: "pendingUnitsConst",
    code: "customer.getWallet('').lockedUnits",
    codeRegexMatcher: /^customer.getWallet+\(['"].*?['"]\).lockedUnits$/g,
    parameter: "('')",
    parameterType: "wallet",
    dialogTitle: "pendingUnitsWalletBalanceAttributes",
  },
  {
    label: "totalEarnedUnitsConst",
    code: "customer.getWallet('').earnedUnits",
    codeRegexMatcher: /^customer.getWallet+\(['"].*?['"]\).earnedUnits$/g,
    parameter: "('')",
    parameterType: "wallet",
    dialogTitle: "totalEarnedUnitsWalletBalanceAttributes",
  },
  {
    label: "usedUnitsConst",
    code: "customer.getWallet('').spentUnits",
    codeRegexMatcher: /^customer.getWallet+\(['"].*?['"]\).spentUnits$/g,
    parameter: "('')",
    parameterType: "wallet",
    dialogTitle: "usedUnitsWalletBalanceAttributes",
  },
];

export const referralCampaignMemberWalletVariables = [
  {
    label: "refereeWalletBalanceAttributes",
    attributes: directMemberWalletAttributes,
  },
  {
    label: "referrerWalletBalanceAttributes",
    attributes: [
      {
        label: "activeUnits",
        code: "referrer.getWallet('').activeUnits",
        codeRegexMatcher: /^referrer.getWallet+\(['"].*?['"]\).activeUnits$/g,
        parameter: "('')",
        parameterType: "wallet",
        dialogTitle: "activeUnitsWalletBalanceAttributes",
      },
      {
        label: "blockedUnits",
        code: "referrer.getWallet('').blockedUnits",
        codeRegexMatcher: /^referrer.getWallet+\(['"].*?['"]\).blockedUnits$/g,
        parameter: "('')",
        parameterType: "wallet",
        dialogTitle: "blockedUnitsWalletBalanceAttributes",
      },
      {
        label: "expiredUnitsConst",
        code: "referrer.getWallet('').expiredUnits",
        codeRegexMatcher: /^referrer.getWallet+\(['"].*?['"]\).expiredUnits$/g,
        parameter: "('')",
        parameterType: "wallet",
        dialogTitle: "expiredUnitsWalletBalanceAttributes",
      },
      {
        label: "pendingUnitsConst",
        code: "referrer.getWallet('').lockedUnits",
        codeRegexMatcher: /^referrer.getWallet+\(['"].*?['"]\).lockedUnits$/g,
        parameter: "('')",
        parameterType: "wallet",
        dialogTitle: "pendingUnitsWalletBalanceAttributes",
      },
      {
        label: "totalEarnedUnitsConst",
        code: "referrer.getWallet('').earnedUnits",
        codeRegexMatcher: /^referrer.getWallet+\(['"].*?['"]\).earnedUnits$/g,
        parameter: "('')",
        parameterType: "wallet",
        dialogTitle: "totalEarnedUnitsWalletBalanceAttributes",
      },
      {
        label: "usedUnitsConst",
        code: "referrer.getWallet('').spentUnits",
        codeRegexMatcher: /^referrer.getWallet+\(['"].*?['"]\).spentUnits$/g,
        parameter: "('')",
        parameterType: "wallet",
        dialogTitle: "usedUnitsWalletBalanceAttributes",
      },
    ],
  },
];

export const directCampaignMemberWalletVariables = [
  {
    label: "walletBalanceAttributes",
    attributes: directMemberWalletAttributes,
  },
];

export const data = {
  templates: [
    {
      label: "fixedAmountOf100Points",
      code: "100",
      codeRegexMatcher: /(?!)/g,
    },
    {
      label: "10PointsForEveryProductWithSpecificSku",
      code: "10*transaction.sku('').qty",
      codeRegexMatcher: /^\d*\.?\d*\*transaction.sku+\(['"].*?['"]\).qty$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "sku",
      dialogDescription: "dialogDescriptionSku",
    },
    {
      label: "20PointsForEveryProductFromSpecificBrand",
      code: "20*transaction.maker('').qty",
      codeRegexMatcher: /^\d*\.?\d*\*transaction.maker+\(['"].*?['"]\).qty$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "brand",
      dialogDescription: "dialogDescriptionBrand",
    },
    {
      label: "1PointFor1UnitCurrencySpent",
      code: "1*transaction.grossValue",
      codeRegexMatcher: /^\d*\.?\d*\*transaction.grossValue$/g,
    },
    {
      label: "1PointFor10UnitsCurrencySpentAndRoundupPoints",
      code: "round_up(0.1*transaction.grossValue)",
      codeRegexMatcher: /^round_up\(\d*\.?\d*\*transaction.grossValue\)$/g,
    },
    {
      label: "1PointFor1UnitCurrencySpent2xPointsEveryProductFromCategory",
      code: "1*transaction.grossValue+2*transaction.category('').grossValue",
      codeRegexMatcher:
        /^\d*\.?\d*\*transaction.grossValue\+\d*\.?\d*\*transaction.category+\(['"].*?['"]\).grossValue$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "category",
      dialogDescription: "dialogDescriptionCategory",
    },
    {
      label: "2PointsFor1UnitCurrencySpentExcludeProductFromBrand",
      code: "2*(transaction.grossValue-transaction.maker('').grossValue)",
      codeRegexMatcher:
        /^\d*\.?\d*\*\(transaction.grossValue-transaction.maker+\(['"].*?['"]\).grossValue\)$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "brand",
      dialogDescription: "dialogDescriptionBrand",
    },
    {
      label: "5PointsForEvery1UnitCurrencySpentOnProductFromBrand",
      code: "5*transaction.maker('').grossValue",
      codeRegexMatcher:
        /^\d*\.?\d*\*transaction.maker+\(['"].*?['"]\).grossValue$/g,
    },
    {
      label: "10UnitsForEveryProductMatchesCriteria",
      code: "10*transaction.itemsCriteria('').qty",
      codeRegexMatcher: /^\d*\.?\d*\*transaction.itemsCriteria+\([^)]*\).qty$/g,
      parameter: "('')",
      parameterType: "itemsCriteria",
      dialogTitle: "unitsForEveryProductThatMatchesSelectedCriterial",
      dialogDescription: "dialogDescriptionItemsCriteria",
    },
    {
      label: "10UnitsForEveryUnitCurrencySpentOnProductMatchesCriteria",
      code: "10*transaction.itemsCriteria('').grossValue",
      codeRegexMatcher:
        /^\d*\.?\d*\*transaction.itemsCriteria+\([^)]*\).grossValue$/g,
      parameter: "('')",
      parameterType: "itemsCriteria",
      dialogTitle: "unitsForEveryProductThatMatchesSelectedCriterial",
      dialogDescription: "dialogDescriptionItemsCriteria",
    },
  ],
  variables: [
    {
      label: "transactionGrossValue",
      code: "transaction.grossValue",
      codeRegexMatcher: /^transaction.grossValue$/g,
    },
    {
      label: "totalNumberOfItemsInTransaction",
      code: "transaction.qty",
      codeRegexMatcher: /^transaction.qty$/g,
    },
    {
      label: "transactionSKUQty",
      code: "transaction.sku('').qty",
      codeRegexMatcher: /^transaction.sku+\(['"].*?['"]\).qty$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "sku",
      dialogDescription: "dialogDescriptionSku",
    },
    {
      label: "grossValueOfProductsWithSpecificSku",
      code: "transaction.sku('').grossValue",
      codeRegexMatcher: /^transaction.sku+\(['"].*?['"]\).grossValue$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "sku",
      dialogDescription: "dialogDescriptionSku",
    },
    {
      label: "transactionCategoryQty",
      code: "transaction.category('').qty",
      codeRegexMatcher: /^transaction.category+\(['"].*?['"]\).qty$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "category",
      dialogDescription: "dialogDescriptionCategory",
    },
    {
      label: "grossValueOfProductsFromSpecificCategory",
      code: "transaction.category('').grossValue",
      codeRegexMatcher: /^transaction.category+\(['"].*?['"]\).grossValue$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "category",
      dialogDescription: "dialogDescriptionCategory",
    },
    {
      label: "transactionBrandQty",
      code: "transaction.maker('').qty",
      codeRegexMatcher: /^transaction.maker+\(['"].*?['"]\).qty$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "brand",
      dialogDescription: "dialogDescriptionBrand",
    },
    {
      label: "grossValueOfProductsFromSpecificBrand",
      code: "transaction.maker('').grossValue",
      codeRegexMatcher: /^transaction.maker+\(['"].*?['"]\).grossValue$/g,
      parameter: "('')",
      parameterType: "text",
      dialogTitle: "brand",
      dialogDescription: "dialogDescriptionBrand",
    },
  ],
};

export const directCampaignData: DataType[] = [
  {
    name: "templates",
    items: data.templates as DataItemType[],
  },
  {
    name: "variables",
    items: [
      ...data.variables,
      ...directCampaignMemberWalletVariables,
    ] as DataItemType[],
  },
];

export const referralCampaignData: DataType[] = [
  {
    name: "templates",
    items: data.templates as DataItemType[],
  },
  {
    name: "variables",
    items: [
      ...data.variables,
      ...referralCampaignMemberWalletVariables,
    ] as DataItemType[],
  },
];
